const ACCENT_MAP: Record<string, string[]> = {
  a: ["á", "à", "â", "ä"],
  e: ["é", "è", "ê", "ë"],
  i: ["í", "ì", "î", "ï"],
  o: ["ó", "ò", "ô", "ö"],
  u: ["ú", "ù", "û", "ü"],
  y: ["ý", "ỳ", "ŷ", "ÿ"],
  n: ["ñ"],
  c: ["ç"],
  ["?"]: ["¿"],
  ["!"]: ["¡"],
};

export const AccentShortcuts: React.FC<{
  children: string;
  onSelect: (accent: string) => void;
}> = ({ children, onSelect }) => {
  const isLowerCase = children === children.toLowerCase();
  const accents = ACCENT_MAP[children.toLowerCase()]?.map((char) =>
    isLowerCase ? char : char.toUpperCase(),
  );

  if (!accents) {
    return null;
  }

  return (
    <div className="absolute left-1/2 top-1/2 py-2 -translate-x-1/2 -translate-y-1/2 title-xl md:py-4">
      &nbsp;
      <div className="absolute bottom-full left-1/2 flex gap-0.5 rounded-btn border bg-base-100 p-0.5 -translate-x-1/2">
        {accents.map((accent, index) => (
          <button
            key={index}
            className="btn btn-square btn-ghost btn-sm rounded-md text-lg font-medium"
            onClick={() => {
              onSelect(accent);
            }}
          >
            {accent}
          </button>
        ))}
      </div>
    </div>
  );
};
